import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CoFounderConnect from './views/CoFounderConnect'
import CofounderOpeningDetail from './components/CofounderOpeningDetail'

export const CoFounderConnectRoutes = () => {


    return (
        <div className='mt-3'>
            <Routes>
                <Route
                    index
                    element={
                        <CoFounderConnect />
                    }
                />
                <Route
                    path='cofounder-details'
                    element={
                        <CofounderOpeningDetail />
                    }
                />
            </Routes>
        </div>
    )
}
